module.exports = __webpack_public_path__ + "img/how-work-5.d056a330.png";